import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import AdminResourceCrudPage from './components/AdminResourceCrudPage';

const formatBytes = (value) => {
  const n = Number(value || 0);
  if (!n) return '0 B';
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(1)} GB`;
};

const AdminArtifactsPage = () => {
  return (
    <AdminResourceCrudPage
      title="Artifact Registry"
      subtitle="Inspect generated reports, binaries, logs, and exported files across all scans."
      icon={Inventory2OutlinedIcon}
      endpoint="/api/admin/artifacts/"
      allowCreate={false}
      allowEdit={false}
      allowDelete={false}
      columns={[
        { key: 'created_at', label: 'Created', render: (row) => new Date(row.created_at).toLocaleString() },
        { key: 'label', label: 'Artifact' },
        { key: 'category', label: 'Category' },
        { key: 'artifact_type', label: 'Type' },
        { key: 'source_tool', label: 'Tool' },
        { key: 'target_value', label: 'Target' },
        { key: 'owner_email', label: 'Owner' },
        { key: 'size_bytes', label: 'Size', render: (row) => formatBytes(row.size_bytes) },
        { key: 'content_type', label: 'Content-Type' }
      ]}
      rowActions={[
        {
          label: 'Open',
          icon: OpenInNewOutlinedIcon,
          visible: (row) => Boolean(row.external_url || row.file),
          onClick: async (row) => {
            const link = row.external_url || row.file;
            if (link) window.open(link, '_blank', 'noopener,noreferrer');
          }
        },
        {
          label: 'Download',
          icon: DownloadOutlinedIcon,
          visible: (row) => Boolean(row.file),
          onClick: async (row) => {
            if (row.file) window.open(row.file, '_blank', 'noopener,noreferrer');
          }
        }
      ]}
    />
  );
};

export default AdminArtifactsPage;
